<template>

  <div id="HearingShowResult">
    <div id="ShowResult">
      <v-layout class="result-body" row wrap justify-center align-center px-4>
        <v-flex xs12>
          <h2 class="main-title">{{ lang.resultTitle }}</h2>
          <h4 style="text-align: center" >{{ lang.subTitle}}</h4>

          <div class="progress-body">
            <h2 class="glanceText">{{ lang.glanceText }}</h2>
            <div class="HearingTest-test--textBold" >
              <span class="results-word " :class="'results-'+scoreText" >{{lang[scoreText+'Text']}}</span>
              <p class="bold-regular results-text" v-if="scoreText == 'normal'">{{lang.glancePerfect}}</p>
              <p class="bold-regular results-text" v-if="scoreText == 'mild'">{{lang.glanceImperfect}}</p>
              <p class="bold-regular results-text" v-if="scoreText == 'moderate'">{{lang.glanceModerate}}</p>
              <p class="bold-regular results-text" v-if="scoreText == 'severe'">{{lang.glanceSevere}}</p>
            </div>

            <div class="progress-result-body">
              <span class="progress-result-gradient"></span>
              <span class="progress-result" v-bind:style="{right:scorePresent+'%'}"></span>
            </div>
            <div class="scoreTexts">
              <div class="scoreText">{{ lang.normalText }}</div>
              <div class="scoreText">{{ lang.mildText }}</div>
              <div class="scoreText">{{ lang.moderateText }}</div>
              <div class="scoreText">{{ lang.severeText }}</div>
            </div>
          </div>
        </v-flex>


        <v-flex xs12>

        </v-flex>


        <v-layout v-if="!canShowResult" row wrap justify-center align-center >
          <v-flex>
            <save-result :result="lang[scoreText+'Text']" :result_params="result_params" @showResult="canShowResult = true"></save-result>
          </v-flex>
        </v-layout>


        <v-layout v-if="canShowResult" row wrap justify-center align-center >
          <v-flex xs12 class="divider-result" xs12 >
            <h2>{{ lang.hlGlanceTitle }}</h2>
            <br>
            <div v-show="scoreText === 'normal'">
              <span class="good"><v-icon large color="green">done</v-icon></span>
              <span>{{ lang.hlGood }}</span>
            </div>
            <div v-show="scoreText !== 'normal'">{{ lang.hlBad }}</div>

            <div v-show="scoreText !== 'normal'">
              <div class="per-answer"  v-if="item.answer === 1" v-for="item in resultQuestionsAnswer" >
                  <span ><v-icon large color="green">done</v-icon></span>
                  <span>  {{ lang['hlAnswer_'+item.question] }}</span>
              </div>
            </div>
          </v-flex>

          <v-flex xs12 class="divider-result" >
            <h2>{{ lang.ptGlanceTitle }}</h2>
            <br>
            <div v-show="scoreText === 'normal'">
              <span class="good"><v-icon large color="green">done</v-icon></span>
              <span>{{ lang.ptGood }}</span>
            </div>
            <div v-show="scoreText !== 'normal'">{{ lang.ptBad }}</div>

            <div class="per-answer" v-show="PureToneCount >= 1 ">
                <div class="ptImg"><img src="../../assets/images/ptVar1.png"/></div>
                <div class="ptTitle"><span>  {{ lang['ptVar1'] }}</span></div>
            </div>
            <div class="per-answer" v-show="PureToneCount >= 1">
              <div class="ptImg"><img src="../../assets/images/ptVar2.png"/></div>
              <div class="ptTitle"><span>  {{ lang['ptVar2'] }}</span></div>
            </div>
            <div class="per-answer" v-show="PureToneCount >= 2">
              <div class="ptImg"><img src="../../assets/images/ptVar3.png"/></div>
              <div class="ptTitle"><span>  {{ lang['ptVar3'] }}</span></div>
            </div>
            <div class="per-answer" v-show="PureToneCount >= 3" >
              <div class="ptImg"><img src="../../assets/images/ptVar4.png"/></div>
              <div class="ptTitle"><span>  {{ lang['ptVar4'] }}</span></div>
            </div>

          </v-flex>

          <v-flex xs12 class="divider-result" >
          <h2>{{ lang.speechGlanceTitle }}</h2>
          <br>

          <v-layout row wrap justify-center align-center grid-list-xs-center>
            <v-flex sm1 xs2 style="text-align: center;" v-for="item in resultSpeechTestAnswers" :key="item.answerText">
              <span v-show="item.answer === 1" class="good"><v-icon large color="green">done</v-icon></span>
              <span v-show="item.answer === 0" class="bad"><v-icon large color="red">close</v-icon></span>
              <div style="text-align: center;">{{ item.answerText }}</div>
            </v-flex>
          </v-layout>

          <v-layout row wrap style="padding: 15px 0">
            <v-flex >
              <div v-show="scoreText === 'normal'">
                <span class="good"><v-icon large color="green">done</v-icon></span>
                <span>{{ lang.sGood }}</span>
              </div>
              <div v-show="scoreText !== 'normal'">{{ lang.sBad }}</div>

            </v-flex>
          </v-layout>

          <v-layout row wrap grid-list-xs-center>

            <v-flex sm2 xs3 class="speechtest-icon-wrap" v-show="scoreText !== 'normal'">
               <div class="speechtest-icon"><img src="./../../assets/images/spt1.png"></div>
               <div class="speechtest-text">{{lang.speechEnvironmentsCrowd}}</div>
            </v-flex>
            <v-flex sm2 xs3 class="speechtest-icon-wrap" v-show="scoreText !== 'normal'">
               <div class="speechtest-icon"><img src="../../assets/images/spt2.png"></div>
               <div class="speechtest-text">{{lang.speechEnvironmentsCar}}</div>
            </v-flex>
            <v-flex sm2 xs3 class="speechtest-icon-wrap" v-show="scoreText !== 'normal'">
               <div class="speechtest-icon"><img src="../../assets/images/spt3.png"></div>
               <div class="speechtest-text">{{lang.speechEnvironmentsParty}}</div>
            </v-flex>

            <v-flex sm2 xs3 class="speechtest-icon-wrap" v-show="scoreText === 'moderate' || scoreText === 'severe'">
               <div class="speechtest-icon"><img src="../../assets/images/spt4.png"></div>
               <div class="speechtest-text">{{lang.speechEnvironmentsRestaurant}}</div>
            </v-flex>
            <v-flex sm2 xs3 class="speechtest-icon-wrap" v-show="scoreText === 'moderate' || scoreText === 'severe'">
               <div class="speechtest-icon"><img src="../../assets/images/spt5.png"></div>
               <div class="speechtest-text">{{lang.speechEnvironmentsMeeting}}</div>
            </v-flex>

            <v-flex sm2 xs3 class="speechtest-icon-wrap" v-show="scoreText === 'severe'">
               <div class="speechtest-icon"><img src="../../assets/images/spt6.png"></div>
               <div class="speechtest-text">{{lang.speechEnvironmentsConversation}}</div>
            </v-flex>
            <v-flex sm2 xs3 class="speechtest-icon-wrap" v-show="scoreText === 'severe'">
               <div class="speechtest-icon"><img src="../../assets/images/spt7.png"></div>
               <div class="speechtest-text">{{lang.speechEnvironmentsHome}}</div>
            </v-flex>
          </v-layout>

        </v-flex>
        </v-layout>


        <v-flex xs12>
          <h3 class="nextStep">{{ lang.somethingToConsiderTitle }}</h3>

          <v-layout row wrap justify-center align-center >
            <v-flex xs6 class="untreatedHearing">{{ lang.untreatedHearingBoldText }}</v-flex>
            <v-flex xs6 class="researchConfirms">
              <span style="font-weight: bold">{{ lang.researchConfirmsBold }}</span>
              <span>{{ lang.researchConfirmsStandard }}</span>
            </v-flex>
          </v-layout>

          <h3 class="nextStep">مرحله بعدی!</h3>
          <div class="nextStepContent">
            <div class="content-important">لطفا جهت هماهنگی و تعیین وقت برای بررسی های حضوری با ما تماس بگیرید!</div>
            <br>
            <a target="_blank" href="http://persia-tone.com/index.php/%D8%AA%D9%85%D8%A7%D8%B3-%D8%A8%D8%A7-%D9%85%D8%A7">برای دیدن اطلاعات تماس اینجا کلیک کنید!</a>
          </div>
        </v-flex>
      </v-layout>
    </div>
  </div>

</template>

<script>

  import Lang from '../../assets/lang';
  import SaveResult from './SaveResult.vue';

export default {
    name: 'HearingShowResult',
    components:{SaveResult},

  mounted() {
      // check user passed prev steps, if not go home!
      if(!window.questionsAnswer || !window.calibrationAnswers || !window.PureToneAnswers || !window.SpeechTestAnswers)
          this.$parent.$router.replace('/');

      this.lang = Lang.Lang;
      this.calculateResult();



      //console.log((this.questionsCount) , (10-this.SpeechTestCount),(this.questionsCount) + (10-this.SpeechTestCount),(this.questionsCount) + (10-this.SpeechTestCount) >= 4);

  },
    data: function () {

        return {
            canShowResult: false,
            scorePresent: 15,
            scoreText: 'normal',
            resultQuestionsAnswer: [],
            questionPerWrongScore: 6.666666666666667,
            questionsCount: 0,
            resultCalibrationAnswers: [],
            resultPureToneAnswers: [],
            PureToneCount: 0.0,
            PureTonePerWrongScore: 8.333333333333333,
            resultSpeechTestAnswers: [],
            SpeechTestCount: 0,
            SpeechTestPerWrongScore: 3.333333333333333,
            lang: [],
            result_params: [],

        }
    },
    methods:{
        calculateResult(){
            let self = this;

            // QUESTIONS
            this.resultQuestionsAnswer = window.questionsAnswer.filter(value => Object.keys(value).length !== null);
            this.resultQuestionsAnswer.forEach(function (val, key) {
                if(val.answer === 1){
                    self.questionsCount++;
                }
            });

            // CALIBRATIONS
            this.resultCalibrationAnswers = window.calibrationAnswers;

            //PURE TONES
            this.resultPureToneAnswers = window.PureToneAnswers;
            this.resultPureToneAnswers.forEach(function (val, key) {
                //console.log(val.answer);
                if(val.answer === 0){
                    self.PureToneCount += window.calibrationAnswers.type === 'speaker' ? 1 : 0.5;
                }
            });

            // SPEECH TEST
            this.resultSpeechTestAnswers = window.SpeechTestAnswers.filter(value => Object.keys(value).length !== null);
            this.resultSpeechTestAnswers.forEach(function (val, key) {
                //console.log(val);
                if(val.answer === 1){
                    self.SpeechTestCount++;
                }
            });

            self.setScoreText();

        },
        setScoreText() {
            let self = this;
            self.scorePresent = (self.questionsCount * self.questionPerWrongScore )+ (self.PureToneCount * self.PureTonePerWrongScore )+ ((10 - self.SpeechTestCount) * self.SpeechTestPerWrongScore);

            if(self.scorePresent > 75.0)
                self.scoreText = 'severe'
            else if(self.scorePresent > 50.0)
                self.scoreText = 'moderate'
            else if(self.scorePresent > 25.0)
                self.scoreText = 'mild'

            if(self.scorePresent < 15)
                self.scorePresent = 15;

            // for save result send to server
            this.result_params = [
                {questionsAnswer:this.resultQuestionsAnswer},
                {calibrationAnswers:this.resultCalibrationAnswers},
                {pureToneAnswers:this.resultPureToneAnswers},
                {speechTestAnswers:this.resultSpeechTestAnswers},
                {scorePresent:this.scorePresent},
                {scoreText:this.scoreText}
            ]


        }
    }
}
</script>

<style scoped>
  #ShowResult{
    background-color: #fff;
    padding: 40px 10px 30px;
    text-align: center;

  }

  .nextStep{
    background: #00b7c6;
    padding: 15px;
    text-align: center;
    color: #fff;
  }
  .nextStepContent{
    padding: 15px;
    border: 3px solid #000;
    border-top: 0;
    text-align: center;
  }
  .content-important{
    font-weight: bold;
    text-align: center;
  }
  .untreatedHearing{
    padding: 15px;
    border: 3px solid orange;
    margin: 15px 0;
  }

  .researchConfirms{
    padding: 15px;
    border: 3px solid green;
    margin: 15px 0;
  }

  @media (max-width: 599px) {

    #ShowResult .result-body{
      padding: 0 !important;
    }
  }
  .speechtest-icon,.speechtest-text{
    text-align: center;
  }
  .HearingTest-test--textBold{

  }
  h2.glanceText{
    border-bottom: 2px dotted #999;
    padding-bottom: 5px;
    margin-bottom: 15px;
  }
  .HearingTest-test--textBold .results-word{
    position: relative;
    color: #FFFFFF;
    background-color: #2ECC40;
    text-align: center;
    line-height: 40px;
    display: inline-block;
    padding: 0 20px;
    box-shadow: -3px 2px 15px rgba(0, 0, 0, 0.2);
    float: none;
    margin-left: 25px;
    text-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2);
    margin-bottom: 10px;
    font-size: 25px;
  }
  .HearingTest-test--textBold .results-word:after {
    content: "";
    position: absolute;
    right: 100%;
    top: 0px;
    width: 0px;
    height: 0px;
    border-top: 20px solid transparent;
    border-right: 10px solid #2ECC40;
    border-bottom: 20px solid transparent;
  }
  .HearingTest-test--textBold .results-word.results-mild{
    background-color: #FFDC00;
  }
  .HearingTest-test--textBold  .results-word.results-mild:after {
    border-right-color: #FFDC00;
  }
  .HearingTest-test--textBold .results-word.results-moderate{
    background-color: #FF851B;
  }
  .HearingTest-test--textBold  .results-word.results-moderate:after {
    border-right-color: #FF851B;
  }
  .HearingTest-test--textBold .results-word.results-severe{
    background-color: #FF4136;
  }
  .HearingTest-test--textBold  .results-word.results-severe:after {
    border-right-color: #FF4136;
  }
  .HearingTest-test--textBold .results-text{
    display: inline-block;
  }
  .progress-body{

  }
  .progress-body .scoreTexts{
    display: flex;
    margin-bottom: 15px;
  }
  .progress-body .scoreText{
    display: inline-flex;
    margin: auto;
  }

  .progress-result-body{
    width: 100%;
    background: #f9f9f9;
    padding: 15px;
    display: inline-block;
    margin: 15px 0 0;
    position: relative;
  }
  .progress-result-body .progress-result-gradient{
    background: linear-gradient(to left, rgb(46, 204, 64), rgb(255, 220, 0), rgb(255, 133, 27), rgb(255, 65, 54)); width: 100%;
    display: block;
    height: 30px;
    position: absolute;
    left: 0;
    right: 0;
    z-index: 1;
    top: 0;
  }
  .progress-result-body .progress-result{
    height: 30px;
    display: block;
    background: #f9f9f9;
    border-radius: 0 ;
    position: absolute;
    left: 0;
    right: 0;
    z-index: 2;
    top: 0;
  }
  #ShowResult h2.main-title{
    padding: 0 25px 0;
    text-align: center;
    font-size: 36px;
    font-weight: normal;
    color: #000;
  }
  .divider-result{
    background: url(../../assets/images/divider-dotted-down.png) no-repeat top center;
    margin-bottom: 10px;
    padding-top: 25px;
  }
  #speechTest button{
    display: block;
    text-align: center;
    cursor: pointer;
    border: none;
    width: 34%;
    margin: 0 auto;
    padding-top: 12px;
    padding-bottom: 10px;
    background-color: #00b7c6;
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 20px;
    color: #fff;
    -webkit-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
    box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
  }
  .per-answer{
    border-bottom: 1px solid #e1e1e1;
    padding: 15px;
    display: flex;
  }
  .per-answer:last-child{
    border-bottom: none;
  }
  .per-answer .ptImg{
    margin: auto 0;
    display: inline-block;
  }
  .per-answer .ptImg img{
    display: inherit;
  }
  .per-answer .ptTitle{
    margin: auto 10px auto 0;
    display: inline-block;
  }
  .tick-icon{
    color: #0d460d;
    border: 3px solid #0d460d;
  }
  .per-st{
    display: inline-flex;
    width: 10%;
    text-align: center;
  }
  .good{
    border: 3px solid green;
    margin: auto;
    text-align: center;
    border-radius: 50%;
    width: 40px;
    display: inline-block;
    height: 40px;
  }
  .bad{
    border: 3px solid red;
    margin: auto;
    text-align: center;
    border-radius: 50%;
    width: 40px;
    display: inline-block;
    height: 40px;
  }

</style>



// WEBPACK FOOTER //
// src/components/HearingTest/HearingShowResult.vue